import React from 'react';
import './BrandingLoader.css';

const BrandingLoader = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <div className="branding-loader-container">
        <div className="branding-loader-spinner"></div>
      </div>
    );
  }

  return <>{children}</>;
};

export default BrandingLoader;
